<template>
    <fragment>
        <Title>{{activityName}}</Title>

        <div :key="index" v-for="(item,index) in infoObj.list">
            <DisneyAnniv v-if="item.tag=='grid'" :activityId="activityId" :activityStatus="activityStatus"
                :openId="openId" :info="item" :enterSource="enterSource" @handleGridClick="handleGridClick" />

        </div>

    </fragment>
</template>

<script>

import DisneyAnniv from '@/components/temp/disneyanniv'
import { isMiniApplets } from "@/utils/browser"
import { getQueryString } from "@/utils/utils"

export default {
    name: 'Disney',
    components: {
        DisneyAnniv
    },
    data() {
        return {
            openId: '', // 用户 openId
            userId: '', // 用户 userId
            activityId: '', // 活动Id
            activityStatus: 0, // 活动状态
            activityName: '', // 活动名称
            infoObj: {}, // eboss配置项
            pageNo: '', // 页面 No
            enterSource: '', // 进入来源
            test: '', // 是否测试环境
        }
    },
    provide() {
        return {
            getEnterSource: () => this.enterSource
        };
    },
    mounted() {
        this.activityId = getQueryString("activityId");
        this.pageNo = getQueryString("pageNo");
        this.openId = getQueryString("openId") || '';
        this.userId = getQueryString("userId") || '';
        this.enterSource = getQueryString("enterSource") || '';
        localStorage.setItem('openId', this.openId)
        localStorage.setItem('userId', this.userId)
        this.test = getQueryString("test")
        let enNewUser = getQueryString("enNewUser") || '0'
        localStorage.setItem('enNewUser', enNewUser)
        this.init()
    },
    methods: {
        init() {
            this.getPageConfig().then(_ => {

            })
            this.$log.senLog({
                pointID: '12020001',
                eventType: 1,
                businessData: {
                    appSource: isMiniApplets() == 'wechat' ? 'WUC' : 'ZUC',
                    enterSource: this.enterSource || ''
                }
            })

        },

        getPageConfig() {
            return new Promise((resolve, reject) => {
                let params = {
                    activityId: this.activityId,
                    openId: this.openId,
                    pageNo: this.pageNo,
                    test: this.test
                };
                this.$ebLoading.show();
                this.$fetch(
                    { url: "/ehs/activity/page/config", method: "post" },
                    params
                ).then(res => {
                    this.$ebLoading.hide();
                    if (res.success) {
                        this.infoObj = {};
                        setTimeout(() => {
                            this.infoObj = JSON.parse(res.model.pageContent);
                            this.activityStatus = res.model.activityStatus;
                            this.activityName = res.model.activityName;
                        }, 300);
                        resolve(res.model.talkingDataAppId);
                    } else {
                        if (res.errorCode == "CLA100077") {
                            console.log("没有页面");
                            return;
                        }
                        this.toast(res.errorMessage)
                    }
                }).finally(() => {
                    this.$ebLoading.hide();
                })
            });
        },

        // 热区点击操作统一跳转
        hotAreaHandleClick(val) {
            if (val.jumpType == 2) {
                this.pageNo = val.urlPath;
                this.getPageConfig();
            } else if ([3, 4].includes(val.jumpType)) {
                this.urlFor(val);
            } else if (val.jumpType == 1) {
                // alert("无");
            }
        },

        // 九宫格点击
        handleGridClick(val) {
            console.log(val)
            this.hotAreaHandleClick(val)
        },

        toast(txt) { // 报错提示
            this.$toast({
                styles: {
                    maskColor: "rgba(0,0,0,0)",
                    background: "rgba(0,0,0,0.4)",
                    messageColor: "#fff"
                },
                content: txt,
                duration: 2000
            }).then(() => {
                console.log("finish");
            });
        },
    }
}
</script>

<style lang="scss" scoped>

</style>
